import { useThemeColors } from './useThemeColors';

export function useButtonColors() {
  const colors = useThemeColors();

  return {
    primary: {
      background: colors.button.primary.background,
      text: colors.button.primary.text,
    },
    secondary: {
      background: colors.button.secondary.background,
      text: colors.button.secondary.text,
    },
  };
}
